"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const deassignEnrolment_1 = tslib_1.__importDefault(require("../../helpers/enrolment/deassignEnrolment"));
const getEnrolmentOfContent_1 = tslib_1.__importDefault(require("../../helpers/enrolment/getEnrolmentOfContent"));
const getLibraryVersion_1 = require("../../helpers/getLibraryVersion");
const command_1 = require("../../type/command");
const entity_1 = require("../../type/entity");
const applyAssignContent_1 = require("../applyAssignContent");
const updateEnrolments_1 = tslib_1.__importDefault(require("../applyAssignContent/updateEnrolments"));
function enrolmentExists(content, user, enrolments, rootContentId) {
    const enrolmentOfContent = getEnrolmentOfContent_1.default(enrolments, content._id, user.userId);
    if (enrolmentOfContent &&
        (enrolmentOfContent.deleted || enrolmentOfContent.parentIds.indexOf(rootContentId) === -1)) {
        return true;
    }
    return false;
}
const isParentDeassigned = (rootEnrolment) => rootEnrolment.deleted;
const getDeassignContentCommand = (command) => {
    const { id, creatorId, timeStamp, rootContentId, userId } = command;
    const deassignCommand = {
        id,
        timeStamp,
        type: command_1.CommandType.DEASSIGN_CONTENT,
        rootContentId,
        creatorId,
        libraryVersion: 1,
        userId,
        deassignerId: creatorId
    };
    return deassignCommand;
};
function handleDeassignedRootEnrolment(command, content, rootEnrolment, allEnrolments, user) {
    try {
        const enrolmentOfContent = getEnrolmentOfContent_1.default(allEnrolments, content._id, user.userId);
        if (isParentDeassigned(rootEnrolment) && enrolmentOfContent) {
            const deassignCommand = getDeassignContentCommand(command);
            deassignEnrolment_1.default(deassignCommand, content, enrolmentOfContent);
        }
    }
    catch (error) {
        throw new Error('Error in handleDeassignedRootEnrolment ' + error);
    }
}
function assignChildContent(command, user, content, states, enrolments, rootEnrolment) {
    const childContents = [];
    const stateInteractions = [];
    const { id, creatorId, timeStamp } = command;
    const { userId } = user;
    const { enrolmentInfo } = rootEnrolment;
    const currentEnrolmentInfo = enrolmentInfo[0];
    const { assignerId, assignmentEventId, assignType } = currentEnrolmentInfo;
    const unitSettings = [
        {
            unitId: content._id,
            type: entity_1.DueDateType.NO_DUE_DATE
        }
    ];
    const assignCommand = {
        type: command_1.CommandType.ASSIGN_CONTENT,
        assignerId,
        assignmentEventId,
        assignType: assignType,
        creatorId,
        id,
        libraryVersion: getLibraryVersion_1.getLibraryVersion(),
        rootContentId: rootEnrolment.contentId,
        timeStamp,
        unitSettings,
        userId,
        versions: command.versions
    };
    let toReturnPayload = {
        events: [],
        states,
        enrolments,
        stateInteractions: []
    };
    if (enrolmentExists(content, user, enrolments, command.rootContentId)) {
        const updatedEnrolments = updateEnrolments_1.default(enrolments, assignCommand, content, user);
        toReturnPayload = {
            events: [],
            states,
            enrolments: updatedEnrolments,
            stateInteractions: []
        };
    }
    else {
        toReturnPayload = applyAssignContent_1.applyAssignContent(assignCommand, user, content, childContents, states, enrolments, stateInteractions);
    }
    handleDeassignedRootEnrolment(command, content, rootEnrolment, toReturnPayload.enrolments, user);
    return toReturnPayload;
}
exports.assignChildContent = assignChildContent;
//# sourceMappingURL=assignChildContent.js.map